import { render } from "./sectionPhotos.vue?vue&type=template&id=23024b8e&scoped=true"
import script from "./sectionPhotos.vue?vue&type=script&lang=js"
export * from "./sectionPhotos.vue?vue&type=script&lang=js"

import "./sectionPhotos.vue?vue&type=style&index=0&id=23024b8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23024b8e"]])

export default __exports__